import { device } from '@/utils/index'

const content = [
    // 第一章 Evaluation
    // 小标题
    {
        key: 'section4.0',
        type: "title",
        category: 7, // *必填* 分类 1：章头 2：节头 3：小标题 ...
        // shortText: '1.1', // 小标题文本，有值的时候展示 例如：第一章、第一节等
        text: "Translation", // *必填* 标题文本内容
        titleImage: require("@/assets/images/books/book2/title-back.png"),
        textStyle: {
            // fontFamily: 'Microsoft Yahei', // 字体，本地配置的字体
            fontSize: 38, // 文字大小  默认：26
            // lineHeight: 40, // 行高  默认：46
            textIndent: 55, // 首行缩进  默认：0 可以使用距离px也可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：加粗
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#5CA683', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
            // backgroundImage: require("@/assets/images/bookContent/chapter_title_bg.png") // 背景图片  默认：无
        },
    },
    {
        key: 'section4.1',
        type: "title",
        category: 4, // *必填* 分类 1：章头 2：节头 3：小标题 ...
        // shortText: '1.1', // 小标题文本，有值的时候展示 例如：第一章、第一节等
        text: "节日名称翻译 Festival Name Translation",
        textStyle: {
            fontFamily: 'Arial', // 字体，本地配置的字体
            fontSize: 32, // 文字大小  默认：26
            lineHeight: 36, // 行高  默认：46
            textIndent: 0, // 首行缩进  默认：0 可以使用距离px也可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：加粗
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            textAlign: 'center', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#333333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
            // backgroundImage: require("@/assets/images/bookContent/chapter_title_bg.png") // 背景图片  默认：无
            marginTop: 30,
        },
    },
    // 模板样式 单个带边框
    {
        key: 'section4.2',
        type: 'template',
        category: 1, // *必填* 分类 1：单个带边框 2：两级tabs 3：可收起模块
        templateStyle: {
            // fontFamily: 'Microsoft Yahei', // 字体，本地配置的字体
            // fontSize: 38, // 文字大小  默认：26
            // lineHeight: 40, // 行高  默认：46
            // textIndent: 55, // 首行缩进  默认：0 可以使用距离px也可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：加粗
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            // color: '#5CA683', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
            marginTop: 30,
            // marginBottom: 30,
            padding: 25,
            backgroundColor: '#D2E3D9',
            // paddingTop: 0,
            // paddingBottom: 0,
            borderRadius: 0,
            border: 'none',
            borderTop: 'none',
            borderBottom: 'none',
            borderLeft: '6rem solid #5CA683',
            borderRight: 'none'
        },
        content: [
            { //右侧文本内容，目前只有一段文字
                key: 'section4.2.1', // *必填* 唯一标识
                type: 'text', // *必填* 类型：正文
                isInTable: true,
                content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                    {
                        key: 'section4.2.1.1', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: "节日是指人们为了纪念某个重要的事件、人物或其他原因而设立的特殊日子。节日在不同地区和文化中有不同的形式和含义。因此，在翻译节日名称时，除了考虑字面意义外，还要充分考虑文化背景、历史传统等因素，以确保准确传达节日的含义和文化内涵。",
                        textStyle: {},
                    }
                ],
                textStyle: {
                    fontFamily: 'Calibri', // 字体，本地配置的字体
                    fontSize: device.isMobile ? 28 : 24,
                    lineHeight: 40,
                    textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                    // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                    // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                    fontItalic: 2, // 斜体 1：斜体 2：正常  默认：2
                    // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                    color: '#333', // 文本颜色  默认：#00a8ac
                    // backgroundColor: '#FFF', // 背景颜色  默认：无
                },
            },
        ],
    },
    {
        key: 'section4.3',
        type: 'paragraph',
        category: 'withBefore',
        leftMark: { // 左侧标记
            type: 'block', // block: 左侧占满 inline：仅第一行有缩进
            width: 40,
            height: 40,
            text: '1',
            textStyle: {
                fontFamily: 'Times New Roman', // 字体，本地配置的字体
                fontSize: 30, // 文字大小  默认：20
                lineHeight: 40, // 行高  默认：36
                // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                textAlign: 'center', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                color: '#fff', // 文本颜色  默认：#00a8ac
                backgroundColor: '#5CA683', // 背景颜色  默认：无
                backgroundImage: "",
                paddingLeft: 0,
                marginLeft: 0,
                marginRight: 14,
                marginTop: 0,
                marginBottom: 0,
                top: 0,
                left: 0,
            }
        },
        content: { //右侧文本内容，目前只有一段文字
            key: 'section4.3.1', // *必填* 唯一标识
            type: 'text', // *必填* 类型：正文
            isInTable: true,
            content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                {
                    key: 'section4.3.1.1', // *必填* 唯一标识
                    category: 'text', // *必填* 内容类型 text：文本
                    text: '传统节日名称的译法', // *必填* 文本内容
                    textStyle: {
                        fontFamily: 'STXihei', // 字体，本地配置的字体
                        fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：加粗
                        fontSize: 28,
                        lineHeight: 40
                    },
                }
            ],
            textStyle: {
                // fontFamily: 'xxx', // 字体，本地配置的字体
                // fontSize: 20, // 文字大小  默认：20
                // lineHeight: 40, // 行高  默认：36
                // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                color: '#333', // 文本颜色  默认：#00a8ac
                // backgroundColor: '#FFF', // 背景颜色  默认：无
            },
        },
        // 段落内外间距
        paragraphStyle: {
            marginTop: 34,
            marginBottom: 22,
            padding: 0,
            paddingLeft: 20,
            paddingRight: 20,
        }
    },
    {
        key: 'section4.4', // *必填* 唯一标识
        type: 'text', // *必填* 类型：正文
        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
            {
                key: 'section4.4.1', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '（', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'STXihei',
                },
            },
            {
                key: 'section4.4.2', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '1', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                    fontWeight: 400,
                    fontFamily: 'STXihei',
                },
            },
            {
                key: 'section4.4.3', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '）直译法。采用直译法直接将节日名称逐字翻译成译入语能够比较完整地保留源语的民族色彩和语言风格。', // *必填* 文本内容
                textStyle: {
                    fontWeight: 400,
                    fontFamily: 'STXihei',
                },
            },
        ],
        textStyle: {
            // fontFamily: 'xxx', // 字体，本地配置的字体
            fontSize: device.isMobile ? 28 : 24,
            lineHeight: 40,
            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无

        },
    },
    //音频翻译
    {
        key: 'section4.5',
        type: 'translationAudio',
        category: '',
        text: ' ',
        textStyle: {
            marginTop: 24,
            marginBottom: 24,
        },
        content: [
            {
                key: 'section4.5.1',
                text: 'e.g.',
                isPlay: false,
                word_url: require('@/assets/audio/4-1/01 the Spring Festival.mp3'), // 单词音频,
                textStyle: {
                    fontFamily: 'Calibri',
                    color: '#fff',
                    fontSize: 26,
                    fontItalic: 1
                },
                content: [
                    {
                        key: 'section4.5.1.1',
                        text: '春节',
                        textStyle: {
                            fontFamily: 'STXihei',
                            color: '#333333',
                            fontSize: 28,
                            lineHeight: 42
                        }
                    },
                    {
                        key: 'section4.5.1.2',
                        text: ' the Spring Festival',
                        textStyle: {
                            fontFamily: 'Times New Roman',
                            color: '#333333',
                            fontSize: 28,
                            lineHeight: 42
                        }
                    }
                ]
            },
            {
                key: 'section4.5.2',
                text: '',
                isPlay: false,
                word_url: require('@/assets/audio/4-1/02 the Mid-Autumn Festival.mp3'), // 单词音频,
                textStyle: {
                    fontFamily: 'STXihei',
                    color: '#333333',
                    fontSize: 28,
                },
                content: [
                    {
                        key: 'section4.5.2.1',
                        text: '中秋节',
                        textStyle: {
                            fontFamily: 'STXihei',
                            color: '#333333',
                            fontSize: 28,
                            lineHeight: 42
                        }
                    },
                    {
                        key: 'section4.5.2.2',
                        text: ' the Mid-Autumn Festival',
                        textStyle: {
                            fontFamily: 'Times New Roman',
                            color: '#333333',
                            fontSize: 28,
                            lineHeight: 42

                        }
                    }
                ]
            },
        ]
    },
    {
        key: 'section4.6', // *必填* 唯一标识
        type: 'text', // *必填* 类型：正文
        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
            {
                key: 'section4.6.1', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '（', // *必填* 文本内容
                textStyle: {
                    fontWeight: 400,
                    fontFamily: 'STXihei',
                },
            },
            {
                key: 'section4.6.2', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '2', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                    fontWeight: 400,
                    fontFamily: 'STXihei',
                },
            },
            {
                key: 'section4.6.3', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '）意译法。翻译时，可根据节日的文化内涵和背景，将其意义传达到译入语中。', // *必填* 文本内容
                textStyle: {
                    fontWeight: 400,
                    fontFamily: 'STXihei',
                },
            },
        ],
        textStyle: {
            // fontFamily: 'xxx', // 字体，本地配置的字体
            fontSize: device.isMobile ? 28 : 24,
            lineHeight: 40,
            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无

        },
    },
    //音频翻译
    {
        key: 'section4.7',
        type: 'translationAudio',
        category: '',
        text: ' ',
        textStyle: {
            marginTop: 24,
            marginBottom: 24,
        },
        content: [
            {
                key: 'section4.7.1',
                text: 'e.g.',
                isPlay: false,
                word_url: require('@/assets/audio/4-1/03 the Lantern Festival.mp3'), // 单词音频,
                textStyle: {
                    fontFamily: 'Calibri',
                    color: '#fff',
                    fontSize: 26,
                    fontItalic: 1
                },
                content: [
                    {
                        key: 'section4.7.1.1',
                        text: '元宵节',
                        textStyle: {
                            fontFamily: 'STXihei',
                            color: '#333333',
                            fontSize: 28,
                            lineHeight: 42
                        }
                    },
                    {
                        key: 'section4.7.1.2',
                        text: ' the Lantern Festival',
                        textStyle: {
                            fontFamily: 'Times New Roman',
                            color: '#333333',
                            fontSize: 28,
                            lineHeight: 42
                        }
                    }
                ]
            },
            {
                key: 'section4.7.2',
                text: '',
                isPlay: false,
                word_url: require('@/assets/audio/4-1/04 the Double Seventh Festival.mp3'), // 单词音频,
                textStyle: {
                    fontFamily: 'STXihei',
                    color: '#333333',
                    fontSize: 28,
                },
                content: [
                    {
                        key: 'section4.7.2.1',
                        text: '七夕节',
                        textStyle: {
                            fontFamily: 'STXihei',
                            color: '#333333',
                            fontSize: 28,
                            lineHeight: 42
                        }
                    },
                    {
                        key: 'section4.7.2.2',
                        text: ' the Double Seventh Festival',
                        textStyle: {
                            fontFamily: 'Times New Roman',
                            color: '#333333',
                            fontSize: 28,
                            lineHeight: 42

                        }
                    }
                ]
            },
            {
                key: 'section4.7.3',
                text: '',
                isPlay: false,
                word_url: require('@/assets/audio/4-1/05 the Tomb-Sweeping Day.mp3'), // 单词音频,
                textStyle: {
                    fontFamily: 'STXihei',
                    color: '#333333',
                    fontSize: 28,
                },
                content: [
                    {
                        key: 'section4.7.3.1',
                        text: '清明节',
                        textStyle: {
                            fontFamily: 'STXihei',
                            color: '#333333',
                            fontSize: 28,
                            lineHeight: 42
                        }
                    },
                    {
                        key: 'section4.7.3.2',
                        text: ' the Tomb-Sweeping Day',
                        textStyle: {
                            fontFamily: 'Times New Roman',
                            color: '#333333',
                            fontSize: 28,
                            lineHeight: 42

                        }
                    }
                ]
            },
            {
                key: 'section4.7.4',
                text: '',
                isPlay: false,
                word_url: require('@/assets/audio/4-1/06 the Double Ninth Festival.mp3'), // 单词音频,
                textStyle: {
                    fontFamily: 'STXihei',
                    color: '#333333',
                    fontSize: 28,
                },
                content: [
                    {
                        key: 'section4.7.4.1',
                        text: '重阳节',
                        textStyle: {
                            fontFamily: 'STXihei',
                            color: '#333333',
                            fontSize: 28,
                            lineHeight: 42
                        }
                    },
                    {
                        key: 'section4.7.4.2',
                        text: ' the Double Ninth Festival',
                        textStyle: {
                            fontFamily: 'Times New Roman',
                            color: '#333333',
                            fontSize: 28,
                            lineHeight: 42

                        }
                    }
                ]
            },
        ]
    },
    {
        key: 'section4.8', // *必填* 唯一标识
        type: 'text', // *必填* 类型：正文
        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
            {
                key: 'section4.8.1', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '（', // *必填* 文本内容
                textStyle: {
                    fontWeight: 400,
                    fontFamily: 'STXihei',
                },
            },
            {
                key: 'section4.8.2', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '3', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                    fontWeight: 400,
                    fontFamily: 'STXihei',
                },
            },
            {
                key: 'section4.8.3', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '）音译法。除以上提到的翻译方法外，有些传统节日名称还可采用音译法进行翻译。这种翻译方法可以保留节日名称原文的美感和文化内涵。', // *必填* 文本内容
                textStyle: {
                    fontWeight: 400,
                    fontFamily: 'STXihei',
                },
            },
        ],
        textStyle: {
            // fontFamily: 'xxx', // 字体，本地配置的字体
            fontSize: device.isMobile ? 28 : 24,
            lineHeight: 40,
            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无

        },
    },
    //音频翻译
    {
        key: 'section4.9',
        type: 'translationAudio',
        category: '',
        text: ' ',
        textStyle: {
            marginTop: 24,
            marginBottom: 24,
        },
        content: [
            {
                key: 'section4.9.1',
                text: 'e.g.',
                isPlay: false,
                word_url: require('@/assets/audio/4-1/07 the Qingming Festival.mp3'), // 单词音频,
                textStyle: {
                    fontFamily: 'Calibri',
                    color: '#fff',
                    fontSize: 26,
                    fontItalic: 1
                },
                content: [
                    {
                        key: 'section4.9.1.1',
                        text: '清明节',
                        textStyle: {
                            fontFamily: 'STXihei',
                            color: '#333333',
                            fontSize: 28,
                            lineHeight: 42
                        }
                    },
                    {
                        key: 'section4.9.1.2',
                        text: ' the Qingming Festival',
                        textStyle: {
                            fontFamily: 'Times New Roman',
                            color: '#333333',
                            fontSize: 28,
                            lineHeight: 42
                        }
                    }
                ]
            },
            {
                key: 'section4.9.2',
                text: '',
                isPlay: false,
                word_url: require('@/assets/audio/4-1/08 the Qixi Festival.mp3'), // 单词音频,
                textStyle: {
                    fontFamily: 'STXihei',
                    color: '#333333',
                    fontSize: 28,
                },
                content: [
                    {
                        key: 'section4.9.2.1',
                        text: '七夕节',
                        textStyle: {
                            fontFamily: 'STXihei',
                            color: '#333333',
                            fontSize: 28,
                            lineHeight: 42
                        }
                    },
                    {
                        key: 'section4.9.2.2',
                        text: ' the Double Seventh Festival',
                        textStyle: {
                            fontFamily: 'Times New Roman',
                            color: '#333333',
                            fontSize: 28,
                            lineHeight: 42

                        }
                    }
                ]
            },
        ]
    },
    {
        key: 'section4.10',
        type: 'paragraph',
        category: 'withBefore',
        leftMark: { // 左侧标记
            type: 'block', // block: 左侧占满 inline：仅第一行有缩进
            width: 40,
            height: 40,
            text: '2',
            textStyle: {
                fontFamily: 'Times New Roman', // 字体，本地配置的字体
                fontSize: 30, // 文字大小  默认：20
                lineHeight: 40, // 行高  默认：36
                // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                textAlign: 'center', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                color: '#fff', // 文本颜色  默认：#00a8ac
                backgroundColor: '#5CA683', // 背景颜色  默认：无
                backgroundImage: "",
                paddingLeft: 0,
                marginLeft: 0,
                marginRight: 14,
                marginTop: 0,
                marginBottom: 0,
                top: 0,
                left: 0,
            }
        },
        content: { //右侧文本内容，目前只有一段文字
            key: 'section4.10.1', // *必填* 唯一标识
            type: 'text', // *必填* 类型：正文
            isInTable: true,
            content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                {
                    key: 'section4.10.1.1', // *必填* 唯一标识
                    category: 'text', // *必填* 内容类型 text：文本
                    text: '国际性节日名称的译法', // *必填* 文本内容
                    textStyle: {
                        fontFamily: 'STXihei', // 字体，本地配置的字体
                        fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：加粗
                        fontSize: 28,
                        lineHeight: 40
                    },
                }
            ],
            textStyle: {
                // fontFamily: 'xxx', // 字体，本地配置的字体
                // fontSize: 20, // 文字大小  默认：20
                // lineHeight: 40, // 行高  默认：36
                // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                color: '#333', // 文本颜色  默认：#00a8ac
                // backgroundColor: '#FFF', // 背景颜色  默认：无
            },
        },
        // 段落内外间距
        paragraphStyle: {
            marginTop: 34,
            marginBottom: 22,
            padding: 0,
            paddingLeft: 20,
            paddingRight: 20,
        }
    },
    {
        key: 'section4.11', // *必填* 唯一标识
        type: 'text', // *必填* 类型：正文
        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
            {
                key: 'section4.11.1', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '直译法。国际性节日是指世界上多数国家都会过的节日。对大部分国际性节日名称进行翻译时，可采用直译法。需要注意的是，对这类节日名称中的“节”或“日”进行翻译时，需要采用表示特殊日期的“', // *必填* 文本内容
                textStyle: {
                    fontWeight: 400,
                    fontFamily: 'STXihei',
                },
            },
            {
                key: 'section4.11.2', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: 'day', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                    fontWeight: 400,
                    fontFamily: 'STXihei',
                },
            },
            {
                key: 'section4.11.3', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '”，而不是表示庆祝活动的“', // *必填* 文本内容
                textStyle: {
                    fontWeight: 400,
                    fontFamily: 'STXihei',
                },
            },
            {
                key: 'section4.11.4', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: 'festival', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                    fontWeight: 400,
                    fontFamily: 'STXihei',
                },
            },
            {
                key: 'section4.11.5', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '”', // *必填* 文本内容
                textStyle: {
                    fontWeight: 400,
                    fontFamily: 'STXihei',
                },
            },
        ],
        textStyle: {
            // fontFamily: 'xxx', // 字体，本地配置的字体
            fontSize: device.isMobile ? 28 : 24,
            lineHeight: 40,
            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无

        },
    },
    //音频翻译
    {
        key: 'section4.12',
        type: 'translationAudio',
        category: '',
        text: ' ',
        textStyle: {
            marginTop: 24,
            marginBottom: 24,
        },
        content: [
            {
                key: 'section4.12.1',
                text: 'e.g.',
                isPlay: false,
                word_url: require('@/assets/audio/4-1/09 International Women’s Day.mp3'), // 单词音频,
                textStyle: {
                    fontFamily: 'Calibri',
                    color: '#fff',
                    fontSize: 26,
                    fontItalic: 1
                },
                content: [
                    {
                        key: 'section4.12.1.1',
                        text: '国际妇女节',
                        textStyle: {
                            fontFamily: 'STXihei',
                            color: '#333333',
                            fontSize: 28,
                            lineHeight: 42
                        }
                    },
                    {
                        key: 'section4.12.1.2',
                        text: ' International Women’s Day',
                        textStyle: {
                            fontFamily: 'Times New Roman',
                            color: '#333333',
                            fontSize: 28,
                            lineHeight: 42
                        }
                    }
                ]
            },
            {
                key: 'section4.12.2',
                text: '',
                isPlay: false,
                word_url: require('@/assets/audio/4-1/10 Father’s Day.mp3'), // 单词音频,
                textStyle: {
                    fontFamily: 'STXihei',
                    color: '#333333',
                    fontSize: 28,
                },
                content: [
                    {
                        key: 'section4.12.2.1',
                        text: '父亲节',
                        textStyle: {
                            fontFamily: 'STXihei',
                            color: '#333333',
                            fontSize: 28,
                            lineHeight: 42
                        }
                    },
                    {
                        key: 'section4.12.2.2',
                        text: ' Father’s Day',
                        textStyle: {
                            fontFamily: 'Times New Roman',
                            color: '#333333',
                            fontSize: 28,
                            lineHeight: 42

                        }
                    }
                ]
            },
            {
                key: 'section4.12.3',
                text: '',
                isPlay: false,
                popWord: true,
                category: 'popover',
                word_url: require('@/assets/audio/4-1/11 World Environment Day.mp3'), // 单词音频,
                textStyle: {
                    fontFamily: 'STXihei',
                    color: '#333333',
                    fontSize: 28,
                },
                content: [
                    {
                        key: 'section4.12.3.3',
                        text: '世界环境日',
                        textStyle: {
                            fontFamily: 'STXihei',
                            color: '#0482EC',
                            fontSize: 28,
                            lineHeight: 42
                        }
                    },
                    {
                        key: 'section4.12.3.4',
                        text: ' World Environment Day',
                        popWord: true,
                        popWord_play: true,
                        isPlay: false,
                        word_url: require('@/assets/audio/4-1/11 World Environment Day.mp3'), // 单词音频,
                        allContent: [
                            {
                                key: 'section4.12.3.4.1',
                                text: '世界环境日',
                                textStyle: {
                                    fontFamily: 'STXihei',
                                    color: '#0482EC',
                                    fontSize: 28,
                                    lineHeight: 42
                                }
                            },
                            {
                                key: 'section4.12.3.4.2',
                                text: ' World Environment Day',
                                textStyle: {
                                    fontFamily: 'Times New Roman',
                                    color: '#0482EC',
                                    fontSize: 28,
                                    lineHeight: 42
                                }
                            },
                        ],
                        popWordTitle: [{
                            key: 'section4.12.3.4.3',
                            text: 'World Environment Day',
                            textStyle: {
                                fontFamily: 'Arial',
                                fontWeight: 'bold',
                                color: '#333',
                                fontSize: 18,
                            }
                        },
                        {
                            key: 'section4.12.3.4.3.2',
                            text: '',
                            textStyle: {
                                fontFamily: 'Calibri',
                                color: '#999999',
                                fontSize: 14,
                            }
                        }
                        ],
                        popWordList: [
                            {
                                key: 'section4.12.3.5',
                                text: '',
                                textStyle: {
                                    fontFamily: 'STXihei',
                                    color: '#333',
                                    fontSize: 14
                                },
                                content: [{
                                    key: 'ssection4.12.3.5.1',
                                    text: '',
                                    // textFlex:true,
                                    textStyle: {},
                                    content: [{
                                        key: 'section4.12.3.5.1.1',
                                        text: "世界环境日由联合国环境规划署牵头，自",
                                        textStyle: {
                                            fontFamily: 'STXihei',
                                            color: '#333',
                                            fontSize: 22,
                                            lineHeight: 36,
                                        },
                                    },
                                    {
                                        key: 'section4.12.3.5.1.2',
                                        text: '1973',
                                        textStyle: {
                                            fontFamily: 'Times New Roman',
                                            color: '#333',
                                            fontSize: 22,
                                            lineHeight: 36
                                        },
                                    },
                                    {
                                        key: 'section4.12.3.5.1.3',
                                        text: "年以来每年于",
                                        textStyle: {
                                            fontFamily: 'STXihei',
                                            color: '#333',
                                            fontSize: 22,
                                            lineHeight: 36,
                                        },
                                    },
                                    {
                                        key: 'section4.12.3.5.1.4',
                                        text: '6',
                                        textStyle: {
                                            fontFamily: 'Times New Roman',
                                            color: '#333',
                                            fontSize: 22,
                                            lineHeight: 36
                                        },
                                    },
                                    {
                                        key: 'section4.12.3.5.1.5',
                                        text: "月",
                                        textStyle: {
                                            fontFamily: 'STXihei',
                                            color: '#333',
                                            fontSize: 22,
                                            lineHeight: 36,
                                        },
                                    },
                                    {
                                        key: 'section4.12.3.5.1.6',
                                        text: '5',
                                        textStyle: {
                                            fontFamily: 'Times New Roman',
                                            color: '#333',
                                            fontSize: 22,
                                            lineHeight: 36
                                        },
                                    },
                                    {
                                        key: 'section4.12.3.5.1.7',
                                        text: "日举行，是联合国鼓励全世界对环境的认识和行动的主要工具，也是联合国促进全球环境意识、提高对环境问题的注意并采取行动的主要媒介之一。如今，世界环境日已发展成为一个全球性的平台，鼓励人们采取行动应对迫在眉睫的环境问题。近年来，数以百万计的民众参与其中，帮助推动我们改变消费习惯，并促进在国家和国际层面完善环境政策。",
                                        textStyle: {
                                            fontFamily: 'STXihei',
                                            color: '#333',
                                            fontSize: 22,
                                            lineHeight: 36,
                                        },
                                    },
                                    ]
                                },]
                            },
                        ],
                        textStyle: {
                            fontFamily: 'Times New Roman',
                            color: '#0482EC',
                            fontSize: 28,
                            lineHeight: 42

                        }
                    }
                ]
            },
            {
                key: 'section4.12.4',
                text: '',
                isPlay: false,
                popWord: true,
                category: 'popover',
                word_url: require('@/assets/audio/4-1/12 World Food Day.mp3'), // 单词音频,
                textStyle: {
                    fontFamily: 'STXihei',
                    color: '#333333',
                    fontSize: 28,
                },
                content: [
                    {
                        key: 'section4.12.4.1',
                        text: '世界粮食日',
                        textStyle: {
                            fontFamily: 'STXihei',
                            color: '#333333',
                            fontSize: 28,
                            lineHeight: 42
                        }
                    },
                    {
                        key: 'section4.12.4.2',
                        text: 'World Food Day',
                        popWord: true,
                        popWord_play: true,
                        isPlay: false,
                        word_url: require('@/assets/audio/4-1/12 World Food Day.mp3'), // 单词音频,
                        allContent: [
                            {
                                key: 'section4.12.4.2.1',
                                text: '世界粮食日',
                                textStyle: {
                                    fontFamily: 'STXihei',
                                    color: '#0482EC',
                                    fontSize: 28,
                                    lineHeight: 42
                                }
                            },
                            {
                                key: 'section4.12.4.2.2',
                                text: ' World Food Day',
                                textStyle: {
                                    fontFamily: 'Times New Roman',
                                    color: '#0482EC',
                                    fontSize: 28,
                                    lineHeight: 42
                                }
                            },
                        ],
                        popWordTitle: [{
                            key: 'section4.12.4.2.3',
                            text: ' World Food Day',
                            textStyle: {
                                fontFamily: 'Arial',
                                fontWeight: 'bold',
                                color: '#333',
                                fontSize: 18,
                            }
                        },
                        {
                            key: 'section4.12.4.2.4',
                            text: '',
                            textStyle: {
                                fontFamily: 'Calibri',
                                color: '#999999',
                                fontSize: 14,
                            }
                        }
                        ],
                        popWordList: [
                            {
                                key: 'section4.12.4.3',
                                text: '',
                                textStyle: {
                                    fontFamily: 'STXihei',
                                    color: '#333',
                                    fontSize: 14
                                },
                                content: [{
                                    key: 'ssection4.12.4.3.1',
                                    text: '',
                                    // textFlex:true,
                                    textStyle: {},
                                    content: [{
                                        key: 'section4.12.4.3.1.1',
                                        text: "世界粮食日起始于",
                                        textStyle: {
                                            fontFamily: 'STXihei',
                                            color: '#333',
                                            fontSize: 22,
                                            lineHeight: 36,
                                        },
                                    },
                                    {
                                        key: 'section4.12.4.3.1.2',
                                        text: '1981',
                                        textStyle: {
                                            fontFamily: 'Times New Roman',
                                            color: '#333',
                                            fontSize: 22,
                                            lineHeight: 36
                                        },
                                    },
                                    {
                                        key: 'section4.12.4.3.1.3',
                                        text: "年",
                                        textStyle: {
                                            fontFamily: 'STXihei',
                                            color: '#333',
                                            fontSize: 22,
                                            lineHeight: 36,
                                        },
                                    },
                                    {
                                        key: 'section4.12.4.3.1.4',
                                        text: '10',
                                        textStyle: {
                                            fontFamily: 'Times New Roman',
                                            color: '#333',
                                            fontSize: 22,
                                            lineHeight: 36
                                        },
                                    },
                                    {
                                        key: 'section4.12.4.3.1.5',
                                        text: "月",
                                        textStyle: {
                                            fontFamily: 'STXihei',
                                            color: '#333',
                                            fontSize: 22,
                                            lineHeight: 36,
                                        },
                                    },
                                    {
                                        key: 'section4.12.4.3.1.6',
                                        text: '16',
                                        textStyle: {
                                            fontFamily: 'Times New Roman',
                                            color: '#333',
                                            fontSize: 22,
                                            lineHeight: 36
                                        },
                                    },
                                    {
                                        key: 'section4.12.4.3.1.7',
                                        text: "日，是世界各国政府每年在",
                                        textStyle: {
                                            fontFamily: 'STXihei',
                                            color: '#333',
                                            fontSize: 22,
                                            lineHeight: 36,
                                        },
                                    },
                                    {
                                        key: 'section4.12.4.3.1.8',
                                        text: '10',
                                        textStyle: {
                                            fontFamily: 'Times New Roman',
                                            color: '#333',
                                            fontSize: 22,
                                            lineHeight: 36
                                        },
                                    },
                                    {
                                        key: 'section4.12.4.3.1.9',
                                        text: "月",
                                        textStyle: {
                                            fontFamily: 'STXihei',
                                            color: '#333',
                                            fontSize: 22,
                                            lineHeight: 36,
                                        },
                                    },
                                    {
                                        key: 'section4.12.4.3.1.10',
                                        text: '16',
                                        textStyle: {
                                            fontFamily: 'Times New Roman',
                                            color: '#333',
                                            fontSize: 22,
                                            lineHeight: 36
                                        },
                                    },
                                    {
                                        key: 'section4.12.4.3.1.11',
                                        text: "日围绕发展粮食和农业生产举行纪念活动的日子，其宗旨在于唤起全世界对发展粮食和农业生产的高度重视。",
                                        textStyle: {
                                            fontFamily: 'STXihei',
                                            color: '#333',
                                            fontSize: 22,
                                            lineHeight: 36,
                                        },
                                    },
                                    ]
                                },]
                            },
                        ],
                        textStyle: {
                            fontFamily: 'Times New Roman',
                            color: '#333333',
                            fontSize: 28,
                            lineHeight: 42

                        }
                    }
                ]
            },
        ]
    },
    {
        key: 'section4.13', // *必填* 唯一标识
        type: 'text', // *必填* 类型：正文
        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
            {
                key: 'section4.13.1', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '（', // *必填* 文本内容
                textStyle: {
                    fontWeight: 400,
                    fontFamily: 'STXihei',
                },
            },
            {
                key: 'section4.13.2', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '2', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                    fontWeight: 400,
                    fontFamily: 'STXihei',
                },
            },
            {
                key: 'section4.13.3', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '）意译法。对一些国际性节日名称进行翻译时，可根据其含义进行翻译，这样能使译文更符合译入语的表达习惯，也更简练。', // *必填* 文本内容
                textStyle: {
                    fontWeight: 400,
                    fontFamily: 'STXihei',
                },
            },
        ],
        textStyle: {
            // fontFamily: 'xxx', // 字体，本地配置的字体
            fontSize: device.isMobile ? 28 : 24,
            lineHeight: 40,
            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无

        },
    },
    //音频翻译
    {
        key: 'section4.14',
        type: 'translationAudio',
        category: '',
        text: ' ',
        textStyle: {
            marginTop: 24,
            marginBottom: 24,
        },
        content: [
            {
                key: 'section4.14.1',
                text: 'e.g.',
                isPlay: false,
                word_url: require('@/assets/audio/4-1/13 New Year’s Day.mp3'), // 单词音频,
                textStyle: {
                    fontFamily: 'Calibri',
                    color: '#fff',
                    fontSize: 26,
                    fontItalic: 1
                },
                content: [
                    {
                        key: 'section4.14.1.1',
                        text: '元旦',
                        textStyle: {
                            fontFamily: 'STXihei',
                            color: '#333333',
                            fontSize: 28,
                            lineHeight: 42
                        }
                    },
                    {
                        key: 'section4.14.1.2',
                        text: ' New Year’s Day',
                        textStyle: {
                            fontFamily: 'Times New Roman',
                            color: '#333333',
                            fontSize: 28,
                            lineHeight: 42
                        }
                    }
                ]
            },
            {
                key: 'section4.14.2',
                text: '',
                isPlay: false,
                popWord: true,
                category: 'popover',
                word_url: require('@/assets/audio/4-1/14 Arbor Day.mp3'), // 单词音频,
                textStyle: {
                    fontFamily: 'STXihei',
                    color: '#333333',
                    fontSize: 28,
                },
                content: [
                    {
                        key: 'section4.14.2.1',
                        text: '植树节',
                        textStyle: {
                            fontFamily: 'STXihei',
                            color: '#333333',
                            fontSize: 28,
                            lineHeight: 42
                        }
                    },
                    {
                        key: 'section4.14.2.2',
                        text: ' Arbor Day',
                        popWord: true,
                        popWord_play: true,
                        isPlay: false,
                        word_url: require('@/assets/audio/4-1/14 Arbor Day.mp3'), // 单词音频,
                        allContent: [
                            {
                                key: 'section4.14.2.2.1',
                                text: '植树节',
                                textStyle: {
                                    fontFamily: 'STXihei',
                                    color: '#0482EC',
                                    fontSize: 28,
                                    lineHeight: 42
                                }
                            },
                            {
                                key: 'section4.14.2.2.2',
                                text: ' Arbor Day',
                                textStyle: {
                                    fontFamily: 'Times New Roman',
                                    color: '#0482EC',
                                    fontSize: 28,
                                    lineHeight: 42
                                }
                            },
                        ],
                        popWordTitle: [{
                            key: 'section4.14.2.3',
                            text: 'World Environment Day',
                            textStyle: {
                                fontFamily: 'Arial',
                                fontWeight: 'bold',
                                color: '#333',
                                fontSize: 18,
                            }
                        },
                        {
                            key: 'section4.14.2.4',
                            text: '',
                            textStyle: {
                                fontFamily: 'Calibri',
                                color: '#999999',
                                fontSize: 14,
                            }
                        }
                        ],
                        popWordList: [
                            {
                                key: 'section4.14.2.5',
                                text: '',
                                textStyle: {
                                    fontFamily: 'STXihei',
                                    color: '#333',
                                    fontSize: 14
                                },
                                content: [{
                                    key: 'section4.14.2.5.1',
                                    text: '',
                                    // textFlex:true,
                                    textStyle: {},
                                    content: [{
                                        key: 'section4.14.2.5.1.1',
                                        text: "植树节是按照法律规定宣传保护树木，并组织动员群众积极参加以植树造林为活动内容的节日。按时间长短可分为植树日、植树周和植树月，共称为国际植树节。我国植树节为每年三月十二日。旨在提倡通过这种活动，激发人们爱林造林的热情，意识到环保的重要性。",
                                        textStyle: {
                                            fontFamily: 'STXihei',
                                            color: '#333',
                                            fontSize: 22,
                                            lineHeight: 36,
                                        },
                                    },
                                    ]
                                },]
                            },
                        ],
                        textStyle: {
                            fontFamily: 'Times New Roman',
                            color: '#333333',
                            fontSize: 28,
                            lineHeight: 42

                        }
                    }
                ]
            },
        ]
    },
    {
        key: 'section4.15',
        type: 'paragraph',
        category: 'withBefore',
        leftMark: { // 左侧标记
            type: 'block', // block: 左侧占满 inline：仅第一行有缩进
            width: 40,
            height: 40,
            text: '3',
            textStyle: {
                fontFamily: 'Times New Roman', // 字体，本地配置的字体
                fontSize: 30, // 文字大小  默认：20
                lineHeight: 40, // 行高  默认：36
                // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                textAlign: 'center', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                color: '#fff', // 文本颜色  默认：#00a8ac
                backgroundColor: '#5CA683', // 背景颜色  默认：无
                backgroundImage: "",
                paddingLeft: 0,
                marginLeft: 0,
                marginRight: 14,
                marginTop: 0,
                marginBottom: 0,
                top: 0,
                left: 0,
            }
        },
        content: { //右侧文本内容，目前只有一段文字
            key: 'section4.15.1', // *必填* 唯一标识
            type: 'text', // *必填* 类型：正文
            isInTable: true,
            content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                {
                    key: 'section4.15.1.1', // *必填* 唯一标识
                    category: 'text', // *必填* 内容类型 text：文本
                    text: '政治性节日名称的译法', // *必填* 文本内容
                    textStyle: {
                        fontFamily: 'STXihei', // 字体，本地配置的字体
                        fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：加粗
                        fontSize: 28,
                        lineHeight: 40
                    },
                }
            ],
            textStyle: {
                // fontFamily: 'xxx', // 字体，本地配置的字体
                // fontSize: 20, // 文字大小  默认：20
                // lineHeight: 40, // 行高  默认：36
                // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                color: '#333', // 文本颜色  默认：#00a8ac
                // backgroundColor: '#FFF', // 背景颜色  默认：无
            },
        },
        // 段落内外间距
        paragraphStyle: {
            marginTop: 34,
            marginBottom: 22,
            padding: 0,
            paddingLeft: 20,
            paddingRight: 20,
        }
    },
    {
        key: 'section4.16', // *必填* 唯一标识
        type: 'text', // *必填* 类型：正文
        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
            {
                key: 'section4.16.1', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '直译法（+省译法）。政治性节日通常是指为了纪念一个国家的历史事件、重大成就或重要人物而设立的节日。对这类节日名称进行翻译时，可采用直译法。若名称中含有动词性的词语，通常省略对这类词语的翻译。', // *必填* 文本内容
                textStyle: {
                    fontWeight: 400,
                    fontFamily: 'STXihei',
                },
            },
        ],
        textStyle: {
            // fontFamily: 'xxx', // 字体，本地配置的字体
            fontSize: device.isMobile ? 28 : 24,
            lineHeight: 40,
            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无

        },
    },
    //音频翻译
    {
        key: 'section4.17',
        type: 'translationAudio',
        category: '',
        text: ' ',
        textStyle: {
            marginTop: 24,
            marginBottom: 24,
        },
        content: [
            {
                key: 'section4.17.1',
                text: 'e.g.',
                isPlay: false,
                word_url: require('@/assets/audio/4-1/15 National Day.mp3'), // 单词音频,
                textStyle: {
                    fontFamily: 'Calibri',
                    color: '#fff',
                    fontSize: 26,
                    fontItalic: 1
                },
                content: [
                    {
                        key: 'section4.17.1.1',
                        text: '国庆节',
                        textStyle: {
                            fontFamily: 'STXihei',
                            color: '#333333',
                            fontSize: 28,
                            lineHeight: 42
                        }
                    },
                    {
                        key: 'section4.17.1.2',
                        text: ' National Day',
                        textStyle: {
                            fontFamily: 'Times New Roman',
                            color: '#333333',
                            fontSize: 28,
                            lineHeight: 42
                        }
                    }
                ]
            },
            {
                key: 'section4.17.2',
                text: '',
                isPlay: false,
                word_url: require('@/assets/audio/4-1/16 Party’s Day.mp3'), // 单词音频,
                textStyle: {
                    fontFamily: 'STXihei',
                    color: '#333333',
                    fontSize: 28,
                },
                content: [
                    {
                        key: 'section4.17.2.1',
                        text: '建党节',
                        textStyle: {
                            fontFamily: 'STXihei',
                            color: '#333333',
                            fontSize: 28,
                            lineHeight: 42
                        }
                    },
                    {
                        key: 'section4.17.2.2',
                        text: ' Party’s Day',
                        textStyle: {
                            fontFamily: 'Times New Roman',
                            color: '#333333',
                            fontSize: 28,
                            lineHeight: 42

                        }
                    }
                ]
            },
        ]
    },
    {
        key: 'section4.18',
        type: 'paragraph',
        category: 'withBefore',
        leftMark: { // 左侧标记
            type: 'block', // block: 左侧占满 inline：仅第一行有缩进
            width: 40,
            height: 40,
            text: '4',
            textStyle: {
                fontFamily: 'Times New Roman', // 字体，本地配置的字体
                fontSize: 30, // 文字大小  默认：20
                lineHeight: 40, // 行高  默认：36
                // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                textAlign: 'center', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                color: '#fff', // 文本颜色  默认：#00a8ac
                backgroundColor: '#5CA683', // 背景颜色  默认：无
                backgroundImage: "",
                paddingLeft: 0,
                marginLeft: 0,
                marginRight: 14,
                marginTop: 0,
                marginBottom: 0,
                top: 0,
                left: 0,
            }
        },
        content: { //右侧文本内容，目前只有一段文字
            key: 'section4.18.1', // *必填* 唯一标识
            type: 'text', // *必填* 类型：正文
            isInTable: true,
            content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                {
                    key: 'section4.18.1.1', // *必填* 唯一标识
                    category: 'text', // *必填* 内容类型 text：文本
                    text: '职业性节日名称的译法', // *必填* 文本内容
                    textStyle: {
                        fontFamily: 'STXihei', // 字体，本地配置的字体
                        fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：加粗
                        fontSize: 28,
                        lineHeight: 40
                    },
                }
            ],
            textStyle: {
                // fontFamily: 'xxx', // 字体，本地配置的字体
                // fontSize: 20, // 文字大小  默认：20
                // lineHeight: 40, // 行高  默认：36
                // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                color: '#333', // 文本颜色  默认：#00a8ac
                // backgroundColor: '#FFF', // 背景颜色  默认：无
            },
        },
        // 段落内外间距
        paragraphStyle: {
            marginTop: 34,
            marginBottom: 22,
            padding: 0,
            paddingLeft: 20,
            paddingRight: 20,
        }
    },
    {
        key: 'section4.19', // *必填* 唯一标识
        type: 'text', // *必填* 类型：正文
        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
            {
                key: 'section4.19.1', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '直译法。职业性节日，也称“行业性节日”，是指为了纪念某个特定职业群体，行业的成就、贡献或历史而设立的节日。对这类节日名称进行翻译时，可采用直译法。', // *必填* 文本内容
                textStyle: {
                    fontWeight: 400,
                    fontFamily: 'STXihei',
                },
            },
        ],
        textStyle: {
            // fontFamily: 'xxx', // 字体，本地配置的字体
            fontSize: device.isMobile ? 28 : 24,
            lineHeight: 40,
            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无

        },
    },
    //音频翻译
    {
        key: 'section4.20',
        type: 'translationAudio',
        category: '',
        text: ' ',
        textStyle: {
            marginTop: 24,
            marginBottom: 24,
        },
        content: [
            {
                key: 'section4.20.1',
                text: 'e.g.',
                isPlay: false,
                word_url: require('@/assets/audio/4-1/17 Teachers’ Day.mp3'), // 单词音频,
                textStyle: {
                    fontFamily: 'Calibri',
                    color: '#fff',
                    fontSize: 26,
                    fontItalic: 1
                },
                content: [
                    {
                        key: 'section4.20.1.1',
                        text: '教师节',
                        textStyle: {
                            fontFamily: 'STXihei',
                            color: '#333333',
                            fontSize: 28,
                            lineHeight: 42
                        }
                    },
                    {
                        key: 'section4.20.1.2',
                        text: ' Teachers’ Day',
                        textStyle: {
                            fontFamily: 'Times New Roman',
                            color: '#333333',
                            fontSize: 28,
                            lineHeight: 42
                        }
                    }
                ]
            },
            {
                key: 'section4.20.2',
                text: '',
                isPlay: false,
                word_url: require('@/assets/audio/4-1/18 Doctors’ Day.mp3'), // 单词音频,
                textStyle: {
                    fontFamily: 'STXihei',
                    color: '#333333',
                    fontSize: 28,
                },
                content: [
                    {
                        key: 'section4.20.2.1',
                        text: '医师节',
                        textStyle: {
                            fontFamily: 'STXihei',
                            color: '#333333',
                            fontSize: 28,
                            lineHeight: 42
                        }
                    },
                    {
                        key: 'section4.20.2.2',
                        text: ' Doctors’ Day',
                        textStyle: {
                            fontFamily: 'Times New Roman',
                            color: '#333333',
                            fontSize: 28,
                            lineHeight: 42

                        }
                    }
                ]
            },
        ]
    },
    {
        key: 'section4.21',
        type: "title",
        category: 8, // *必填* 分类 1：章头 2：节头 3：小标题 ...
        // shortText: '1.1', // 小标题文本，有值的时候展示 例如：第一章、第一节等
        text: "Exercises", // *必填* 标题文本内容
        titleImageType: 1,
        titleImage: require("@/assets/images/books/book2/title-icon1.png"),
        textStyle: {
            fontFamily: 'Arial', // 字体，本地配置的字体
            fontSize: 32, // 文字大小  默认：26
            height: 49,
            width: 'auto',
            lineHeight: 49, // 行高  默认：46
            textIndent: 20, // 首行缩进  标题前带图标的写30，不带图标的写20
            color: '#fff', // 文本颜色  默认：#00a8ac
            backgroundColor: '#5CA683', // 背景颜色  默认：无
            marginLeft: 20,
            paddingRight: 20,
            margin: 24,
            marginTop: 20,
            marginBottom: 0,
        },

    },
    // 模板样式 单个带边框
    {
        key: 'section4.22',
        type: 'template',
        category: 1, // *必填* 分类 1：单个带边框 2：两级tabs 3：可收起模块
        templateStyle: {
            // fontFamily: 'Microsoft Yahei', // 字体，本地配置的字体
            // fontSize: 38, // 文字大小  默认：26
            // lineHeight: 40, // 行高  默认：46
            // textIndent: 55, // 首行缩进  默认：0 可以使用距离px也可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：加粗
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            // color: '#5CA683', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
            // marginTop: 30,
            // marginBottom: 30,
            padding: 0,
            marginTop: 5,
            backgroundColor: '#FFFFFF',
            // paddingTop: 0,
            // paddingBottom: 0,
            borderRadius: 0,
            // border: '',
            // borderTop: '',
            // borderBottom: ''
        },

        content: [
            // 音频
            {
                key: 'section4.22.1', // *必填* 唯一标识
                type: 'audio', // *必填* 类型：视频
                templateType: 1, // *必填* 板式 1：全部显示-平铺 2：两个并列-平铺 3：视频集 4：左右滑动
                playerInline: 1, // 是否是行内播放 1：行内播放
                styleType: 1, // 使用的样式 1：机械制图中使用的样式 默认为封面+标题
                content: [ // *必填* 视频列表
                    {
                        key: 'section4.22.1.1', // *必填* 唯一标识
                        url: require("@/assets/video/book2/Whileyoulisten.mp3"), // *必填* 视频地
                        title: 'Dialogue', // 视频标题
                        subtitle: 'Dialogue', // 视频副标题 只在全部显示时使用
                        titleStyle: {
                            // 根据需要是否加标题样式
                            // fontFamily: 'xxx', // 字体，本地配置的字体
                            // fontSize: 20, // 文字大小  默认：20
                            // lineHeight: 40, // 行高  默认：36
                            // textIndent: 40, // 首行缩进  默认：40 或者可以使用字节数2em
                            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                            // color: '#333', // 文本颜色  默认：#00a8ac
                            // backgroundColor: '#FFF', // 背景颜色  默认：无
                        }
                    },
                ],
            },
            {
                key: 'section4.22.2',
                type: 'paragraph',
                category: 'withBefore',
                leftMark: { // 左侧标记
                    type: 'block', // block: 左侧占满 inline：仅第一行有缩进
                    width: 55,
                    height: 40,
                    text: 'I',
                    textStyle: {
                        // fontFamily: 'xxx', // 字体，本地配置的字体
                        fontSize: 24, // 文字大小  默认：20
                        lineHeight: 40, // 行高  默认：36
                        // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                        // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                        // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                        // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                        textAlign: 'center', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                        color: '#fff', // 文本颜色  默认：#00a8ac
                        // backgroundColor: '#5CA683', // 背景颜色  默认：无
                        backgroundImage: require("@/assets/images/books/book2/title-mark-icon.png"),
                        paddingLeft: 0,
                        paddingRight: 15,
                        marginLeft: 0,
                        marginRight: 14,
                        marginTop: 0,
                        marginBottom: 0,
                        top: 0,
                        left: 0,
                    },
                    popContent: { // 气泡
                        key: 'section4.22.2.1', // *必填* 唯一标识
                        category: 'popover', // *必填* 内容类型 text：文本
                        // text: '轴线', // *必填* 文本内容
                        textSlot: 1, // 是否以插槽方式引入内容
                        // popTitle: '轴线的名词解释',
                        popText: '',

                        content: [{
                            key: 'section4.22.2.1.1', // *必填* 唯一标识
                            type: 'text', // *必填* 类型：正文
                            isInTable: true,

                            content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                {
                                    key: 'section4.22.2.1.1.1', // *必填* 唯一标识
                                    category: 'text', // *必填* 内容类型 text：文本
                                    text: '参考答案', // *必填* 文本内容
                                    textStyle: {
                                        fontFamily: 'MicrosoftYaHei', // 字体，本地配置的字体
                                        fontSize: '24px',
                                        fontWeight: 'bold'
                                    },
                                },
                            ],
                            textStyle: {
                                color: '#111', // 文本颜色  默认：#00a8ac
                            },
                        },
                        {
                            key: 'section4.22.2.1.2', // *必填* 唯一标识
                            type: 'text', // *必填* 类型：正文
                            isInTable: true,
                            content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                {
                                    key: 'section4.22.2.1.2.1', // *必填* 唯一标识
                                    category: 'text', // *必填* 内容类型 text：文本
                                    text: '1. the Cold Food Festival', // *必填* 文本内容
                                    textStyle: {
                                        fontFamily: 'Calibri', // 字体，本地配置的字体
                                        fontSize: '24px',
                                    },
                                },
                            ],
                            textStyle: {
                                color: '#111', // 文本颜色  默认：#00a8ac
                            },
                        },
                        {
                            key: 'section4.22.2.1.3', // *必填* 唯一标识
                            type: 'text', // *必填* 类型：正文
                            isInTable: true,
                            content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                {
                                    key: 'section4.22.2.1.3.1', // *必填* 唯一标识
                                    category: 'text', // *必填* 内容类型 text：文本
                                    text: '2. the Dragon Boat Festival', // *必填* 文本内容
                                    textStyle: {
                                        fontFamily: 'Calibri', // 字体，本地配置的字体
                                        fontSize: '24px',
                                    },
                                },
                            ],
                            textStyle: {
                                color: '#111', // 文本颜色  默认：#00a8ac
                            },
                        },
                        {
                            key: 'section4.22.2.1.4', // *必填* 唯一标识
                            type: 'text', // *必填* 类型：正文
                            isInTable: true,
                            content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                {
                                    key: 'section4.22.2.1.4.1', // *必填* 唯一标识
                                    category: 'text', // *必填* 内容类型 text：文本
                                    text: '3. the Ghost Festival', // *必填* 文本内容
                                    textStyle: {
                                        fontFamily: 'Calibri', // 字体，本地配置的字体
                                        fontSize: '24px',
                                    },
                                },
                            ],
                            textStyle: {
                                color: '#111', // 文本颜色  默认：#00a8ac
                            },
                        },
                        {
                            key: 'section4.22.2.1.5', // *必填* 唯一标识
                            type: 'text', // *必填* 类型：正文
                            isInTable: true,
                            content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                {
                                    key: 'section4.22.2.1.5.1', // *必填* 唯一标识
                                    category: 'text', // *必填* 内容类型 text：文本
                                    text: '4. Mother’s Day', // *必填* 文本内容
                                    textStyle: {
                                        fontFamily: 'Calibri', // 字体，本地配置的字体
                                        fontSize: '24px',
                                    },
                                },
                            ],
                            textStyle: {
                                color: '#111', // 文本颜色  默认：#00a8ac
                            },
                        },
                        {
                            key: 'section4.22.2.1.6', // *必填* 唯一标识
                            type: 'text', // *必填* 类型：正文
                            isInTable: true,
                            content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                {
                                    key: 'section4.22.2.1.6.1', // *必填* 唯一标识
                                    category: 'text', // *必填* 内容类型 text：文本
                                    text: '5. Children’s Day', // *必填* 文本内容
                                    textStyle: {
                                        fontFamily: 'Calibri', // 字体，本地配置的字体
                                        fontSize: '24px',
                                    },
                                },
                            ],
                            textStyle: {
                                color: '#111', // 文本颜色  默认：#00a8ac
                            },
                        },
                        {
                            key: 'section4.22.2.1.7', // *必填* 唯一标识
                            type: 'text', // *必填* 类型：正文
                            isInTable: true,
                            content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                {
                                    key: 'section4.22.2.1.7.1', // *必填* 唯一标识
                                    category: 'text', // *必填* 内容类型 text：文本
                                    text: '6. World No Tobacco Day', // *必填* 文本内容
                                    textStyle: {
                                        fontFamily: 'Calibri', // 字体，本地配置的字体
                                        fontSize: '24px',
                                    },
                                },
                            ],
                            textStyle: {
                                color: '#111', // 文本颜色  默认：#00a8ac
                            },
                        },
                        {
                            key: 'section4.22.2.1.8', // *必填* 唯一标识
                            type: 'text', // *必填* 类型：正文
                            isInTable: true,
                            content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                {
                                    key: 'section4.22.2.1.8.1', // *必填* 唯一标识
                                    category: 'text', // *必填* 内容类型 text：文本
                                    text: '7. Youth Day', // *必填* 文本内容
                                    textStyle: {
                                        fontFamily: 'Calibri', // 字体，本地配置的字体
                                        fontSize: '24px',
                                    },
                                },
                            ],
                            textStyle: {
                                color: '#111', // 文本颜色  默认：#00a8ac
                            },
                        },
                        {
                            key: 'section4.22.2.1.9', // *必填* 唯一标识
                            type: 'text', // *必填* 类型：正文
                            isInTable: true,
                            content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                {
                                    key: 'section4.22.2.1.9.1', // *必填* 唯一标识
                                    category: 'text', // *必填* 内容类型 text：文本
                                    text: '8. Army Day', // *必填* 文本内容
                                    textStyle: {
                                        fontFamily: 'Calibri', // 字体，本地配置的字体
                                        fontSize: '24px',
                                    },
                                },
                            ],
                            textStyle: {
                                color: '#111', // 文本颜色  默认：#00a8ac
                            },
                        },
                        {
                            key: 'section4.22.2.1.10', // *必填* 唯一标识
                            type: 'text', // *必填* 类型：正文
                            isInTable: true,
                            content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                {
                                    key: 'section4.22.2.1.10.1', // *必填* 唯一标识
                                    category: 'text', // *必填* 内容类型 text：文本
                                    text: '9. Nurses Day', // *必填* 文本内容
                                    textStyle: {
                                        fontFamily: 'Calibri', // 字体，本地配置的字体
                                        fontSize: '24px',
                                    },
                                },
                            ],
                            textStyle: {
                                color: '#111', // 文本颜色  默认：#00a8ac
                            },
                        },
                        {
                            key: 'section4.22.2.1.11', // *必填* 唯一标识
                            type: 'text', // *必填* 类型：正文
                            isInTable: true,
                            content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                {
                                    key: 'section4.22.2.1.11.1', // *必填* 唯一标识
                                    category: 'text', // *必填* 内容类型 text：文本
                                    text: '10. Journalists’ Day', // *必填* 文本内容
                                    textStyle: {
                                        fontFamily: 'Calibri', // 字体，本地配置的字体
                                        fontSize: '24px',
                                    },
                                },
                            ],
                            textStyle: {
                                color: '#111', // 文本颜色  默认：#00a8ac
                            },
                        },
                        ],
                        textStyle: {

                        },
                    },
                },
                content: { //右侧文本内容，目前只有一段文字
                    key: 'section4.22.2.2', // *必填* 唯一标识
                    type: 'question', // *必填* 类型：正文
                    isInTable: true,
                    isRefresh:true,//是否显示刷新按钮
                    answerType:1,//1:寒食节列表
                    // listContent:[
                    //     {
                    //         key: 'section1.9.3.0.1', // *必填* 唯一标识
                    //         type: 'text', // *必填* 类型：答题
                    //         textStyle:{
                    //         }
                    //      },
                    //      {
                    //         key: 'section1.9.3.0.2', // *必填* 唯一标识
                    //         type: 'text11', // *必填* 类型：答题
                    //         textStyle:{
                    //         }
                    //      }
                    // ],
                    content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                        {
                            key: 'section4.22.2.2.1', // *必填* 唯一标识
                            category: 'text', // *必填* 内容类型 text：文本
                            text: 'Translate the following festival names into English.', // *必填* 文本内容
                            
                            textStyle: {
                                fontFamily: 'ArialMT', // 字体，本地配置的字体
                                fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：加粗
                                fontSize: 28
                            },

                        }
                    ],
                    textStyle: {
                        // fontFamily: 'xxx', // 字体，本地配置的字体
                        // fontSize: 20, // 文字大小  默认：20
                        // lineHeight: 40, // 行高  默认：36
                        // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                        // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                        // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                        // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                        // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                        color: '#333', // 文本颜色  默认：#00a8ac
                        // backgroundColor: '#FFF', // 背景颜色  默认：无
                    },
                },
                // 段落内外间距
                paragraphStyle: {
                    marginTop: 0,
                    marginBottom: 50,
                    padding: 0,
                    paddingLeft: 20,
                    paddingRight: 20
                },
            },
            //寒食节列表
            {
                key: 'section4.22.3', // *必填* 唯一标识
                type: 'question', // *必填* 类型：答题
                onlyContent: 1,
                submitBtnStyle: { //按钮的样式
                    width: 180,
                    height: 52,
                    lineHeight: 52, // 行高  默认：46
                    backgroundColor: '#F6A84C', // 背景颜色  默认：无
                },
                contentList: [
                    {
                        key: 'section4.22.3.1', // *必填* 唯一标识
                        type: 'text', // *必填* 类型：正文
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '寒食节', // *必填* 文本内容
                        popWord_play: true,
                        translate: true,
                        ispop: true,
                        inputW: true,
                        textStyle: {
                            fontSize: 28,
                            color: "#333",
                            fontFamily: 'STXihei', // 字体，本地配置的字体
                        },
                        allContent: [
                            {
                                key: 'section4.22.3.1.1',
                                text: '寒食节',
                                textStyle: {
                                    fontFamily: 'STXihei',
                                    color: '#0482EC',
                                    fontSize: 28,
                                    lineHeight: 42,
                                    fontWeight: 400
                                }
                            },
                        ],
                        popWordList: [
                            {
                                key: 'section4.22.3.1.2',
                                text: '',
                                textStyle: {
                                    fontFamily: 'STXihei',
                                    color: '#333',
                                    fontSize: 14
                                },
                                content: [{
                                    key: 'section4.22.3.1.2.1',
                                    // textFlex:true,
                                    content: [{
                                        key: 'section4.22.3.1.2.1.1',
                                        text: "寒食节，亦称“禁烟节”“冷节”“百五节”，是中国历史上一个独具特色的传统节日。寒食节前后绵延两千余年，曾被称为民间第一大祭日。起初节日日期及时长都不定，后来逐渐固定在冬至后",
                                        textStyle: {
                                            fontFamily: 'STXihei',
                                            color: '#333',
                                            fontSize: 22,
                                            lineHeight: 36,
                                        },
                                    },
                                    {
                                        key: 'section4.22.3.1.2.1.2',
                                        text: '105',
                                        textStyle: {
                                            fontFamily: 'Times New Roman',
                                            color: '#333',
                                            fontSize: 22,
                                            lineHeight: 36
                                        },
                                    },
                                    {
                                        key: 'section4.22.3.1.2.1.3',
                                        text: "天或",
                                        textStyle: {
                                            fontFamily: 'STXihei',
                                            color: '#333',
                                            fontSize: 22,
                                            lineHeight: 36,
                                        },
                                    },
                                    {
                                        key: 'section4.22.3.1.2.1.4',
                                        text: '106',
                                        textStyle: {
                                            fontFamily: 'Times New Roman',
                                            color: '#333',
                                            fontSize: 22,
                                            lineHeight: 36
                                        },
                                    },
                                    {
                                        key: 'section4.22.3.1.2.1.5',
                                        text: "天，即清明节前一二日。在这一日，禁烟火，只吃冷食，所以叫做“寒食节”。在后世的发展中，逐渐增加了祭扫、踏青、秋千、蹴鞠、牵勾、斗卵等风俗。因为和清明节距离较近，所以逐渐把这两个节日合并在一起度过。",
                                        textStyle: {
                                            fontFamily: 'STXihei',
                                            color: '#333',
                                            fontSize: 22,
                                            lineHeight: 36,
                                        },
                                    },
                                    ]
                                },]
                            },
                        ],
                    },
                    {
                        key: 'section4.22.3.2', // *必填* 唯一标识
                        type: 'text', // *必填* 类型：正文
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '端午节', // *必填* 文本内容
                        popWord_play: false,
                        translate: false,
                        inputW: true,
                        textStyle: {
                            fontSize: 28,
                            color: "#333333",
                            fontFamily: 'STXihei', // 字体，本地配置的字体
                            
                            fontWeight: 400
                        },
                    },
                    {
                        key: 'section4.22.3.3', // *必填* 唯一标识
                        type: 'text', // *必填* 类型：正文
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '中元节', // *必填* 文本内容
                        popWord_play: false,
                        translate: false,
                        inputW: true,
                        textStyle: {
                            fontSize: 28,
                            color: "#333333",
                            fontFamily: 'STXihei', // 字体，本地配置的字体
                            fontWeight: 400
                        },

                    },
                    {
                        key: 'section4.22.3.4', // *必填* 唯一标识
                        type: 'text', // *必填* 类型：正文
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '母亲节', // *必填* 文本内容
                        popWord_play: false,
                        translate: false,
                        inputW: true,
                        textStyle: {
                            fontSize: 28,
                            color: "#333333",
                            fontFamily: 'STXihei', // 字体，本地配置的字体
                            fontWeight: 400
                        },

                    },
                    {
                        key: 'section4.22.3.5', // *必填* 唯一标识
                        type: 'text', // *必填* 类型：正文
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '儿童节', // *必填* 文本内容
                        popWord_play: false,
                        translate: false,
                        inputW: true,
                        textStyle: {
                            fontSize: 28,
                            color: "#333333",
                            fontFamily: 'STXihei', // 字体，本地配置的字体
                            fontWeight: 400
                        },
                    },
                    {
                        key: 'section4.22.3.6', // *必填* 唯一标识
                        type: 'text', // *必填* 类型：正文
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '世界无烟日', // *必填* 文本内容
                        popWord_play: true,
                        translate: true,
                        ispop: true,
                        inputW: true,
                        textStyle: {
                            fontSize: 28,
                            color: "#333",
                            fontFamily: 'STXihei', // 字体，本地配置的字体
                        },
                        allContent: [
                            {
                                key: 'section4.22.3.6.1',
                                text: '世界无烟日',
                                textStyle: {
                                    fontFamily: 'STXihei',
                                    color: '#0482EC',
                                    fontSize: 28,
                                    lineHeight: 42,
                                    fontWeight: 400
                                }
                            },
                        ],
                        popWordList: [
                            {
                                key: 'section4.22.3.6.2',
                                text: '',
                                textStyle: {
                                    fontFamily: 'STXihei',
                                    color: '#333',
                                    fontSize: 14
                                },
                                content: [{
                                    key: 'section4.22.3.6.2.1',
                                    // textFlex:true,
                                    content: [{
                                        key: 'section4.22.3.6.2.1.1',
                                        text: "世界无烟日来源于",
                                        textStyle: {
                                            fontFamily: 'STXihei',
                                            color: '#333',
                                            fontSize: 22,
                                            lineHeight: 36,
                                        },
                                    },
                                    {
                                        key: 'section4.22.3.6.2.1.2',
                                        text: '1987',
                                        textStyle: {
                                            fontFamily: 'Times New Roman',
                                            color: '#333',
                                            fontSize: 22,
                                            lineHeight: 36
                                        },
                                    },
                                    {
                                        key: 'section4.22.3.6.2.1.3',
                                        text: "年",
                                        textStyle: {
                                            fontFamily: 'STXihei',
                                            color: '#333',
                                            fontSize: 22,
                                            lineHeight: 36,
                                        },
                                    },
                                    {
                                        key: 'section4.22.3.6.2.1.4',
                                        text: '11',
                                        textStyle: {
                                            fontFamily: 'Times New Roman',
                                            color: '#333',
                                            fontSize: 22,
                                            lineHeight: 36
                                        },
                                    },
                                    {
                                        key: 'section4.22.3.6.2.1.5',
                                        text: "月世界卫生组织（",
                                        textStyle: {
                                            fontFamily: 'STXihei',
                                            color: '#333',
                                            fontSize: 22,
                                            lineHeight: 36,
                                        },
                                    },
                                    {
                                        key: 'section4.22.3.6.2.1.6',
                                        text: 'WHO',
                                        textStyle: {
                                            fontFamily: 'Times New Roman',
                                            color: '#333',
                                            fontSize: 22,
                                            lineHeight: 36
                                        },
                                    },
                                    {
                                        key: 'section4.22.3.6.2.1.7',
                                        text: "）在日本东京举行的第",
                                        textStyle: {
                                            fontFamily: 'STXihei',
                                            color: '#333',
                                            fontSize: 22,
                                            lineHeight: 36,
                                        },
                                    },
                                    {
                                        key: 'section4.22.3.6.2.1.8',
                                        text: '6',
                                        textStyle: {
                                            fontFamily: 'Times New Roman',
                                            color: '#333',
                                            fontSize: 22,
                                            lineHeight: 36
                                        },
                                    },
                                    {
                                        key: 'section4.22.3.6.2.1.9',
                                        text: "届吸烟与健康国际会议，会议上建议将节日定为每年的",
                                        textStyle: {
                                            fontFamily: 'STXihei',
                                            color: '#333',
                                            fontSize: 22,
                                            lineHeight: 36,
                                        },
                                    },
                                    {
                                        key: 'section4.22.3.6.2.1.10',
                                        text: '4',
                                        textStyle: {
                                            fontFamily: 'Times New Roman',
                                            color: '#333',
                                            fontSize: 22,
                                            lineHeight: 36
                                        },
                                    },
                                    {
                                        key: 'section4.22.3.6.2.1.11',
                                        text: "月",
                                        textStyle: {
                                            fontFamily: 'STXihei',
                                            color: '#333',
                                            fontSize: 22,
                                            lineHeight: 36,
                                        },
                                    },
                                    {
                                        key: 'section4.22.3.6.2.1.12',
                                        text: '7',
                                        textStyle: {
                                            fontFamily: 'Times New Roman',
                                            color: '#333',
                                            fontSize: 22,
                                            lineHeight: 36
                                        },
                                    },
                                    {
                                        key: 'section4.22.3.6.2.1.13',
                                        text: "日，并从",
                                        textStyle: {
                                            fontFamily: 'STXihei',
                                            color: '#333',
                                            fontSize: 22,
                                            lineHeight: 36,
                                        },
                                    },
                                    {
                                        key: 'section4.22.3.6.2.1.14',
                                        text: '1988',
                                        textStyle: {
                                            fontFamily: 'Times New Roman',
                                            color: '#333',
                                            fontSize: 22,
                                            lineHeight: 36
                                        },
                                    },
                                    {
                                        key: 'section4.22.3.6.2.1.15',
                                        text: "年开始执行，但从",
                                        textStyle: {
                                            fontFamily: 'STXihei',
                                            color: '#333',
                                            fontSize: 22,
                                            lineHeight: 36,
                                        },
                                    },
                                    {
                                        key: 'section4.22.3.6.2.1.16',
                                        text: '1989',
                                        textStyle: {
                                            fontFamily: 'Times New Roman',
                                            color: '#333',
                                            fontSize: 22,
                                            lineHeight: 36
                                        },
                                    },
                                    {
                                        key: 'section4.22.3.6.2.1.17',
                                        text: "年开始，世界无烟日改为每年的",
                                        textStyle: {
                                            fontFamily: 'STXihei',
                                            color: '#333',
                                            fontSize: 22,
                                            lineHeight: 36,
                                        },
                                    },
                                    {
                                        key: 'section4.22.3.6.2.1.18',
                                        text: '5',
                                        textStyle: {
                                            fontFamily: 'Times New Roman',
                                            color: '#333',
                                            fontSize: 22,
                                            lineHeight: 36
                                        },
                                    },
                                    {
                                        key: 'section4.22.3.6.2.1.19',
                                        text: "月",
                                        textStyle: {
                                            fontFamily: 'STXihei',
                                            color: '#333',
                                            fontSize: 22,
                                            lineHeight: 36,
                                        },
                                    },
                                    {
                                        key: 'section4.22.3.6.2.1.20',
                                        text: '31',
                                        textStyle: {
                                            fontFamily: 'Times New Roman',
                                            color: '#333',
                                            fontSize: 22,
                                            lineHeight: 36
                                        },
                                    },
                                    {
                                        key: 'section4.22.3.6.2.1.21',
                                        text: "日，因为第二天是国际儿童节，希望下一代免受烟草危害。",
                                        textStyle: {
                                            fontFamily: 'STXihei',
                                            color: '#333',
                                            fontSize: 22,
                                            lineHeight: 36,
                                        },
                                    },
                                    ]
                                },]
                            },
                        ],
                    },
                    {
                        key: 'section4.22.3.7', // *必填* 唯一标识
                        type: 'text', // *必填* 类型：正文
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '青年节', // *必填* 文本内容
                        popWord_play: false,
                        translate: false,
                        inputW: true,
                        textStyle: {
                            fontSize: 28,
                            color: "#333333",
                            fontFamily: 'STXihei', // 字体，本地配置的字体
                            fontWeight: 400
                        },

                    },
                    {
                        key: 'section4.22.3.8', // *必填* 唯一标识
                        type: 'text', // *必填* 类型：正文
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '建军节', // *必填* 文本内容
                        popWord_play: false,
                        translate: false,
                        inputW: true,
                        textStyle: {
                            fontSize: 28,
                            color: "#333333",
                            fontFamily: 'STXihei', // 字体，本地配置的字体
                            fontWeight: 400
                        },

                    },
                    {
                        key: 'section4.22.3.9', // *必填* 唯一标识
                        type: 'text', // *必填* 类型：正文
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '护士节', // *必填* 文本内容
                        popWord_play: true,
                        translate: true,
                        ispop: true,
                        inputW: true,
                        textStyle: {
                            fontSize: 28,
                            color: "#333",
                            fontFamily: 'STXihei', // 字体，本地配置的字体
                        },
                        allContent: [
                            {
                                key: 'section4.22.3.9.1',
                                text: '护士节',
                                textStyle: {
                                    fontFamily: 'STXihei',
                                    color: '#0482EC',
                                    fontSize: 28,
                                    lineHeight: 42,
                                    fontWeight: 400
                                }
                            },
                        ],
                        popWordList: [
                            {
                                key: 'section4.22.3.9.2',
                                text: '',
                                textStyle: {
                                    fontFamily: 'STXihei',
                                    color: '#333',
                                    fontSize: 14
                                },
                                content: [{
                                    key: 'section4.22.3.9.2.1',
                                    // textFlex:true,
                                    content: [{
                                        key: 'section4.22.3.9.2.1.1',
                                        text: "国际护士节是每年的",
                                        textStyle: {
                                            fontFamily: 'STXihei',
                                            color: '#333',
                                            fontSize: 22,
                                            lineHeight: 36,
                                        },
                                    },
                                    {
                                        key: 'section4.22.3.9.2.1.2',
                                        text: '5',
                                        textStyle: {
                                            fontFamily: 'Times New Roman',
                                            color: '#333',
                                            fontSize: 22,
                                            lineHeight: 36
                                        },
                                    },
                                    {
                                        key: 'section4.22.3.9.2.1.3',
                                        text: "月",
                                        textStyle: {
                                            fontFamily: 'STXihei',
                                            color: '#333',
                                            fontSize: 22,
                                            lineHeight: 36,
                                        },
                                    },
                                    {
                                        key: 'section4.22.3.9.2.1.4',
                                        text: '12',
                                        textStyle: {
                                            fontFamily: 'Times New Roman',
                                            color: '#333',
                                            fontSize: 22,
                                            lineHeight: 36
                                        },
                                    },
                                    {
                                        key: 'section4.22.3.9.2.1.5',
                                        text: "日，是国际护士理事会为纪念现代护理学科的创始人弗洛伦斯·南丁格尔于",
                                        textStyle: {
                                            fontFamily: 'STXihei',
                                            color: '#333',
                                            fontSize: 22,
                                            lineHeight: 36,
                                        },
                                    },
                                    {
                                        key: 'section4.22.3.9.2.1.6',
                                        text: '1912',
                                        textStyle: {
                                            fontFamily: 'Times New Roman',
                                            color: '#333',
                                            fontSize: 22,
                                            lineHeight: 36
                                        },
                                    },
                                    {
                                        key: 'section4.22.3.9.2.1.7',
                                        text: "年设立的节日。其基本宗旨是倡导、继承和弘扬南丁格尔不畏艰险、甘于奉献、救死扶伤、勇于献身的人道主义精神。",
                                        textStyle: {
                                            fontFamily: 'STXihei',
                                            color: '#333',
                                            fontSize: 22,
                                            lineHeight: 36,
                                        },
                                    },

                                    ]
                                },]
                            },
                        ],
                    },
                    {
                        key: 'section4.22.3.10', // *必填* 唯一标识
                        type: 'text', // *必填* 类型：正文
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '记者节', // *必填* 文本内容
                        popWord_play: true,
                        translate: true,
                        ispop: true,
                        inputW: true,
                        textStyle: {
                            fontSize: 28,
                            color: "#333",
                            fontFamily: 'STXihei', // 字体，本地配置的字体
                        },
                        allContent: [
                            {
                                key: 'section4.22.3.10.1',
                                text: '记者节',
                                textStyle: {
                                    fontFamily: 'STXihei',
                                    color: '#0482EC',
                                    fontSize: 28,
                                    lineHeight: 42,
                                    fontWeight: 400
                                }
                            },
                        ],
                        popWordList: [
                            {
                                key: 'section4.22.3.10.2',
                                text: '',
                                textStyle: {
                                    fontFamily: 'STXihei',
                                    color: '#333',
                                    fontSize: 14
                                },
                                content: [{
                                    key: 'section4.22.3.10.2.1',
                                    // textFlex:true,
                                    content: [{
                                        key: 'section4.22.3.10.2.1.1',
                                        text: "记者节，有些国家又称新闻节、出版节。每年的",
                                        textStyle: {
                                            fontFamily: 'STXihei',
                                            color: '#333',
                                            fontSize: 22,
                                            lineHeight: 36,
                                        },
                                    },
                                    {
                                        key: 'section4.22.3.10.2.1.2',
                                        text: '11',
                                        textStyle: {
                                            fontFamily: 'Times New Roman',
                                            color: '#333',
                                            fontSize: 22,
                                            lineHeight: 36
                                        },
                                    },
                                    {
                                        key: 'section4.22.3.10.2.1.3',
                                        text: "月",
                                        textStyle: {
                                            fontFamily: 'STXihei',
                                            color: '#333',
                                            fontSize: 22,
                                            lineHeight: 36,
                                        },
                                    },
                                    {
                                        key: 'section4.22.3.10.2.1.4',
                                        text: '8',
                                        textStyle: {
                                            fontFamily: 'Times New Roman',
                                            color: '#333',
                                            fontSize: 22,
                                            lineHeight: 36
                                        },
                                    },
                                    {
                                        key: 'section4.22.3.10.2.1.5',
                                        text: "日是中国记者节。",
                                        textStyle: {
                                            fontFamily: 'STXihei',
                                            color: '#333',
                                            fontSize: 22,
                                            lineHeight: 36,
                                        }
                                    },
                                    ]
                                },]
                            },
                        ],
                    },
                ]
            },
            {
                key: 'section4.22.4',
                type: 'paragraph',
                category: 'withBefore',
                leftMark: { // 左侧标记
                    type: 'block', // block: 左侧占满 inline：仅第一行有缩进
                    width: 55,
                    height: 40,
                    text: 'II',
                    textStyle: {
                        // fontFamily: 'xxx', // 字体，本地配置的字体
                        fontSize: 24, // 文字大小  默认：20
                        lineHeight: 40, // 行高  默认：36
                        // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                        // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                        // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                        // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                        textAlign: 'center', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                        color: '#fff', // 文本颜色  默认：#00a8ac
                        // backgroundColor: '#5CA683', // 背景颜色  默认：无
                        backgroundImage: require("@/assets/images/books/book2/title-mark-icon.png"),
                        paddingLeft: 0,
                        paddingRight: 15,
                        marginLeft: 0,
                        marginRight: 14,
                        marginTop: 0,
                        marginBottom: 0,
                        top: 0,
                        left: 0,
                    },
                    popContent: { // 气泡
                        key: 'section4.22.4.1', // *必填* 唯一标识
                        category: 'popover', // *必填* 内容类型 text：文本
                        // text: '轴线', // *必填* 文本内容
                        textSlot: 1, // 是否以插槽方式引入内容
                        // popTitle: '轴线的名词解释',
                        popText: '',
                        content: [{
                            key: 'section4.22.4.1.1', // *必填* 唯一标识
                            type: 'text', // *必填* 类型：正文
                            isInTable: true,
                            content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                {
                                    key: 'section4.22.4.1.1.1', // *必填* 唯一标识
                                    category: 'text', // *必填* 内容类型 text：文本
                                    text: '参考答案', // *必填* 文本内容
                                    textStyle: {
                                        fontFamily: 'MicrosoftYaHei', // 字体，本地配置的字体
                                        fontSize: '24px',
                                        fontWeight: 'bold'
                                    },
                                },
                            ],
                            textStyle: {
                                // fontFamily: 'xxx', // 字体，本地配置的字体
                                // fontSize: 20, // 文字大小  默认：20
                                // lineHeight: 40, // 行高  默认：36
                                textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                                // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                                // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                color: '#111', // 文本颜色  默认：#00a8ac
                                // backgroundColor: '#FFF', // 背景颜色  默认：无
                            },
                        },
                        {
                            key: 'section4.22.4.1.2', // *必填* 唯一标识
                            type: 'text', // *必填* 类型：正文
                            isInTable: true,
                            content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                {
                                    key: 'section4.22.4.1.2.1', // *必填* 唯一标识
                                    category: 'text', // *必填* 内容类型 text：文本
                                    text: '1. The eighth day of the last lunar month is the most significant festival of this month, called “Lari” in ancient times, commonly known as “the Laba Festival”.', // *必填* 文本内容
                                    textStyle: {
                                        fontFamily: 'Calibri', // 字体，本地配置的字体
                                        fontSize: '24px',

                                    },
                                },
                            ],
                            textStyle: {
                                // fontFamily: 'xxx', // 字体，本地配置的字体
                                // fontSize: 20, // 文字大小  默认：20
                                // lineHeight: 40, // 行高  默认：36
                                textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                                // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                                // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                color: '#111', // 文本颜色  默认：#00a8ac
                                // backgroundColor: '#FFF', // 背景颜色  默认：无
                            },
                        },
                        {
                            key: 'section4.22.4.1.3', // *必填* 唯一标识
                            type: 'text', // *必填* 类型：正文
                            isInTable: true,
                            content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                {
                                    key: 'section4.22.4.1.3.1', // *必填* 唯一标识
                                    category: 'text', // *必填* 内容类型 text：文本
                                    text: '2. Labor Day is a national holiday in more than eighty countries in the world and is a festival shared by laborers all over the world.', // *必填* 文本内容
                                    textStyle: {
                                        fontFamily: 'Calibri', // 字体，本地配置的字体
                                        fontSize: '24px',

                                    },
                                },
                            ],
                            textStyle: {
                                // fontFamily: 'xxx', // 字体，本地配置的字体
                                // fontSize: 20, // 文字大小  默认：20
                                // lineHeight: 40, // 行高  默认：36
                                textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                                // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                                // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                color: '#111', // 文本颜色  默认：#00a8ac
                                // backgroundColor: '#FFF', // 背景颜色  默认：无
                            },
                        },


                        ],
                        textStyle: {

                        },
                    },
                },
                content: { //右侧文本内容，目前只有一段文字
                    key: 'section4.22.4.2', // *必填* 唯一标识
                    type: 'text', // *必填* 类型：正文
                    isInTable: true,
                    isRefresh:true,//是否显示刷新按钮
                    answerType:2,//1:寒食节列表  2.简答题
                    content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                        {
                            key: 'section4.22.4.2.1', // *必填* 唯一标识
                            category: 'text', // *必填* 内容类型 text：文本
                            text: 'Translate the following sentences into English. ', // *必填* 文本内容
                            textStyle: {
                                fontFamily: 'ArialMT', // 字体，本地配置的字体
                                fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：加粗
                                fontSize: 28
                            },
                        }
                    ],
                    textStyle: {
                        // fontFamily: 'xxx', // 字体，本地配置的字体
                        // fontSize: 20, // 文字大小  默认：20
                        // lineHeight: 40, // 行高  默认：36
                        // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                        // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                        // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                        // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                        // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                        color: '#333', // 文本颜色  默认：#00a8ac
                        // backgroundColor: '#FFF', // 背景颜色  默认：无
                    },
                },
                // 段落内外间距
                paragraphStyle: {
                    marginTop: 0,
                    marginBottom: 50,
                    padding: 0,
                    paddingLeft: 20,
                    paddingRight: 20,
                }
            },
            // 答题
            {
                key: 'section4.22.5', // *必填* 唯一标识
                type: 'question', // *必填* 类型：答题
                onlyContent: 1, // 只存在内容
                refreshSection:'section4.22.4.2',//刷新按钮的标识
                submitBtnStyle: { //按钮的样式
                    width: 180,
                    height: 52,
                    lineHeight: 52, // 行高  默认：46
                    backgroundColor: '#F6A84C', // 背景颜色  默认：无
                },
                content: [
                    {
                        "topic_id": 57,
                        "id": 57,
                        "type_id": 4,
                        "typenm": "简答题",
                        "shorttag": "",
                        "showway": "",
                        "topic_score": "8.00",
                        "isauto": 0,
                        "info": "",
                        "km": "",
                        "stem_url": "",
                        "audiofile": "",
                        "audiofile_suffix": "",
                        "audiofile_title": "附件下载",
                        "is_collect": 0,
                        "status": 0,
                        "is_play": 0,
                        "issign": 0,
                        "isok": 0,
                        "isdone": 0,
                        "getscore": 0,
                        "comment": "",
                        "ischeck": 0,
                        "ps_info": "根据相关要求，完成下列题目。",
                        "topic_sub": [{
                            "shorttag": "",
                            "direction": 0,
                            "type_id": 4,
                            "typenm": "简答题",
                            "score": "8.00",
                            "topic_id": 57,
                            "sub_id": 1,
                            "isauto": 0,
                            "is_upload": 0,
                            "para44_id": 0,
                            "upload_explain": "",
                            "options": [],
                            "showway": "",
                            "subinfo": "<p style=\"margin-top:0pt; margin-bottom:0pt; text-align:left; line-height:150%; font-family:STXihei; color: #5CA683;font-size:26rem;font-weight:400; \"><span style=\"font-family:'STXihei'; display: flex;\"><span style=\"font-style: italic; margin-right: 16rem;\">1 <\/span>腊月最重大的节日是十二月初八，古代称为“腊日”，俗称“腊八节”。<\/span><\/p>",
                            "subanalysis": "",
                            "sortid": 1,
                            "file_name": "",
                            "user_answer": [],
                            "brief_answer": {},
                            "user_status": -1,
                            "answer_img": {},
                            "topic_answer": [{
                                "topic_id": 57,
                                "sub_id": 1,
                                "sortid": 1,
                                "ask": "",
                                "answer": "",
                                "askend": null,
                                "answer_id": 1,
                                "answer_url": "",
                                "answertitle": null,
                                "score": "8.00",
                                "operation_score": 0
                            }],
                            "video_list": [],
                            "isok": 0,
                            "isdone": 0,
                            "concat_answer": "",
                            "user_concat_answer": ""
                        }]
                    },
                    {
                        "topic_id": 57,
                        "id": 57,
                        "type_id": 4,
                        "typenm": "简答题",
                        "shorttag": "",
                        "showway": "",
                        "topic_score": "8.00",
                        "isauto": 0,
                        "info": "",
                        "km": "",
                        "stem_url": "",
                        "audiofile": "",
                        "audiofile_suffix": "",
                        "audiofile_title": "附件下载",
                        "is_collect": 0,
                        "status": 0,
                        "is_play": 0,
                        "issign": 0,
                        "isok": 0,
                        "isdone": 0,
                        "getscore": 0,
                        "comment": "",
                        "ischeck": 0,
                        "ps_info": "根据相关要求，完成下列题目。",
                        "topic_sub": [{
                            "shorttag": "",
                            "direction": 0,
                            "type_id": 4,
                            "typenm": "简答题",
                            "score": "8.00",
                            "topic_id": 57,
                            "sub_id": 1,
                            "isauto": 0,
                            "is_upload": 0,
                            "para44_id": 0,
                            "upload_explain": "",
                            "options": [],
                            "showway": "",
                            "subinfo": "<p style=\"margin-top:0pt; margin-bottom:0pt; text-align:left; line-height:150%; font-family:STXihei; color: #5CA683;font-size:26rem;font-weight:400; \"><span style=\"font-family:'STXihei'; display: flex;\"><span style=\"font-style: italic; margin-right: 16rem;\">2 <\/span>劳动节是世界上80多个国家的全国性节日，是全世界劳动人民共同拥有的节日。<\/span><\/p>",
                            "subanalysis": "",
                            "sortid": 1,
                            "file_name": "",
                            "user_answer": [],
                            "brief_answer": {},
                            "user_status": -1,
                            "answer_img": {},
                            "topic_answer": [{
                                "topic_id": 57,
                                "sub_id": 1,
                                "sortid": 1,
                                "ask": "",
                                "answer": "",
                                "askend": null,
                                "answer_id": 1,
                                "answer_url": "",
                                "answertitle": null,
                                "score": "8.00",
                                "operation_score": 0
                            }],
                            "video_list": [],
                            "isok": 0,
                            "isdone": 0,
                            "concat_answer": "",
                            "user_concat_answer": ""
                        }]
                    }
                ],
                completeType: '', // 答题完成后的操作 statistics：展示统计结果
            },

        ],
    },
    // 模板样式 单个带边框
    {
        key: 'section4.23',
        type: 'template',
        category: 1, // *必填* 分类 1：单个带边框 2：两级tabs 3：可收起模块
        templateStyle: {
            // fontFamily: 'Microsoft Yahei', // 字体，本地配置的字体
            // fontSize: 38, // 文字大小  默认：26
            // lineHeight: 40, // 行高  默认：46
            // textIndent: 55, // 首行缩进  默认：0 可以使用距离px也可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：加粗
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            // color: '#5CA683', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
            // marginTop: 30,
            // marginBottom: 30,
            padding: 0,
            marginTop: 5,
            backgroundColor: '#FFFFFF',
            // paddingTop: 0,
            // paddingBottom: 0,
            borderRadius: 0,
            // border: '',
            // borderTop: '',
            // borderBottom: ''
        },
        content: [
            // 音频
            {
                key: 'section4.23.1', // *必填* 唯一标识
                type: 'audio', // *必填* 类型：视频
                templateType: 1, // *必填* 板式 1：全部显示-平铺 2：两个并列-平铺 3：视频集 4：左右滑动
                playerInline: 1, // 是否是行内播放 1：行内播放
                styleType: 1, // 使用的样式 1：机械制图中使用的样式 默认为封面+标题
                content: [ // *必填* 视频列表
                    {
                        key: 'section4.23.1.1', // *必填* 唯一标识
                        url: require("@/assets/video/book2/Whileyoulisten.mp3"), // *必填* 视频地
                        title: 'Dialogue', // 视频标题
                        subtitle: 'Dialogue', // 视频副标题 只在全部显示时使用
                        titleStyle: {
                            // 根据需要是否加标题样式
                            // fontFamily: 'xxx', // 字体，本地配置的字体
                            // fontSize: 20, // 文字大小  默认：20
                            // lineHeight: 40, // 行高  默认：36
                            // textIndent: 40, // 首行缩进  默认：40 或者可以使用字节数2em
                            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                            // color: '#333', // 文本颜色  默认：#00a8ac
                            // backgroundColor: '#FFF', // 背景颜色  默认：无
                        }
                    },
                ],
            },
            {
                key: 'section4.23.2',
                type: 'paragraph',
                category: 'withBefore',
                leftMark: { // 左侧标记
                    type: 'block', // block: 左侧占满 inline：仅第一行有缩进
                    width: 55,
                    height: 40,
                    text: 'III',
                    textStyle: {
                        // fontFamily: 'xxx', // 字体，本地配置的字体
                        fontSize: 24, // 文字大小  默认：20
                        lineHeight: 40, // 行高  默认：36
                        // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                        // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                        // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                        // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                        textAlign: 'center', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                        color: '#fff', // 文本颜色  默认：#00a8ac
                        // backgroundColor: '#5CA683', // 背景颜色  默认：无
                        backgroundImage: require("@/assets/images/books/book2/title-mark-icon.png"),
                        paddingLeft: 0,
                        paddingRight: 15,
                        marginLeft: 0,
                        marginRight: 14,
                        marginTop: 0,
                        marginBottom: 0,
                        top: 0,
                        left: 0,
                    },
                    popContent: { // 气泡
                        key: 'section4.23.2.1', // *必填* 唯一标识
                        category: 'popover', // *必填* 内容类型 text：文本
                        // text: '轴线', // *必填* 文本内容
                        textSlot: 1, // 是否以插槽方式引入内容
                        // popTitle: '轴线的名词解释',
                        popText: '',
                        content: [{
                            key: 'section4.23.2.1.1', // *必填* 唯一标识
                            type: 'text', // *必填* 类型：正文
                            isInTable: true,
                            content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                {
                                    key: 'section4.23.2.1.1.1', // *必填* 唯一标识
                                    category: 'text', // *必填* 内容类型 text：文本
                                    text: '参考答案', // *必填* 文本内容
                                    textStyle: {
                                        fontFamily: 'MicrosoftYaHei', // 字体，本地配置的字体
                                        fontSize: '24px',
                                        fontWeight: 'bold'
                                    },
                                },
                            ],
                            textStyle: {
                                // fontFamily: 'xxx', // 字体，本地配置的字体
                                // fontSize: 20, // 文字大小  默认：20
                                // lineHeight: 40, // 行高  默认：36
                                textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                                // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                                // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                color: '#111', // 文本颜色  默认：#00a8ac
                                // backgroundColor: '#FFF', // 背景颜色  默认：无
                            },
                        },
                        {
                            key: 'section4.23.2.1.2', // *必填* 唯一标识
                            type: 'text', // *必填* 类型：正文
                            isInTable: true,
                            content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                {
                                    key: 'section4.23.2.1.2.1', // *必填* 唯一标识
                                    category: 'text', // *必填* 内容类型 text：文本
                                    text: 'The ninth day of the ninth lunar month marks a significant traditional festival for the Chinese nation, known as the Double Ninth Festival. The origins of this festival can be traced back to the Spring and Autumn Period and the Warring States Period, boasting a history that exceeds 2,000 years. Celebratory activities typically include enjoying scenic views, mountain climbing, admiring chrysanthemums, and partaking in chrysanthemum wine. Due to the homophonic relationship between “ninety-nine” and “long-lasting”, this festival symbolizes longevity, thus, the Double Ninth Festival is also called Seniors’ Day. In 1989, China officially designated this date as “Chinese Seniors Day” or “Respect for the Elderly Day”. Consequently, the Double Ninth Festival has evolved into an occasion dedicated to honoring seniors, promoting respect for them while fostering love and support.', // *必填* 文本内容
                                    textStyle: {
                                        fontFamily: 'Calibri', // 字体，本地配置的字体
                                        fontSize: '24px',
                                    },
                                },
                            ],
                            textStyle: {
                                // fontFamily: 'xxx', // 字体，本地配置的字体
                                // fontSize: 20, // 文字大小  默认：20
                                // lineHeight: 40, // 行高  默认：36
                                textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                                // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                                // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                color: '#111', // 文本颜色  默认：#00a8ac
                                // backgroundColor: '#FFF', // 背景颜色  默认：无
                            },
                        },



                        ],
                        textStyle: {

                        },
                    },
                },
                content: { //右侧文本内容，目前只有一段文字
                    key: 'section4.23.2.2', // *必填* 唯一标识
                    type: 'text', // *必填* 类型：正文
                    isInTable: true,
                    isRefresh:true,//是否显示刷新按钮
                    answerType:2,//1:寒食节列表  2.简答题
                    content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                        {
                            key: 'section4.23.2.2.1', // *必填* 唯一标识
                            category: 'text', // *必填* 内容类型 text：文本
                            text: 'Translate the following passage into English.', // *必填* 文本内容
                            textStyle: {
                                fontFamily: 'ArialMT', // 字体，本地配置的字体
                                fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：加粗
                                fontSize: 28
                            },
                        }
                    ],
                    textStyle: {
                        // fontFamily: 'xxx', // 字体，本地配置的字体
                        // fontSize: 20, // 文字大小  默认：20
                        // lineHeight: 40, // 行高  默认：36
                        // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                        // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                        // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                        // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                        // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                        color: '#333', // 文本颜色  默认：#00a8ac
                        // backgroundColor: '#FFF', // 背景颜色  默认：无
                    },
                },
                // 段落内外间距
                paragraphStyle: {
                    marginTop: 0,
                    marginBottom: 50,
                    padding: 0,
                    paddingLeft: 20,
                    paddingRight: 20,
                }
            },
            {
                key: 'section4.23.3', // *必填* 唯一标识
                type: 'audio', // *必填* 类型：视频
                templateType: 1, // *必填* 板式 1：全部显示-平铺 2：两个并列-平铺 3：视频集 4：左右滑动
                playerInline: 1, // 是否是行内播放 1：行内播放
                styleType: 1, // 使用的样式 1：机械制图中使用的样式 默认为封面+标题
                content: [ // *必填* 视频列表
                    {
                        key: 'section4.23.3.1', // *必填* 唯一标识
                        url: require("@/assets/audio/4-4/重阳节.mp3"), // *必填* 视频地
                        title: '参考译文', // 视频标题
                        subtitle: 'Dialogue', // 视频副标题 只在全部显示时使用
                        contentStyle: {
                            //   width: '100%',
                            marginTop: 30,
                            marginBottom: 30,
                        },
                    },
                ],
            },
            // 答题
            {
                key: 'section4.23.4', // *必填* 唯一标识
                type: 'question', // *必填* 类型：答题
                onlyContent: 1, // 只存在内容
                refreshSection:'section4.23.2.2',//刷新按钮的标识
                submitBtnStyle: { //按钮的样式
                    width: 180,
                    height: 52,
                    lineHeight: 52, // 行高  默认：46
                    backgroundColor: '#F6A84C', // 背景颜色  默认：无
                },
                content: [
                    {
                        "topic_id": 57,
                        "id": 57,
                        "type_id": 4,
                        "typenm": "简答题",
                        "shorttag": "",
                        "showway": "",
                        "topic_score": "8.00",
                        "isauto": 0,
                        "info": "",
                        "km": "",
                        "stem_url": "",
                        "audiofile": "",
                        "audiofile_suffix": "",
                        "audiofile_title": "附件下载",
                        "is_collect": 0,
                        "status": 0,
                        "is_play": 0,
                        "issign": 0,
                        "isok": 0,
                        "isdone": 0,
                        "getscore": 0,
                        "comment": "",
                        "ischeck": 0,
                        "ps_info": "根据相关要求，完成下列题目。",
                        "topic_sub": [{
                            "shorttag": "",
                            "direction": 0,
                            "type_id": 4,
                            "textareaHeightSize": 'big',
                            "typenm": "简答题",
                            "score": "8.00",
                            "topic_id": 57,
                            "sub_id": 1,
                            "isauto": 0,
                            "is_upload": 0,
                            "para44_id": 0,
                            "upload_explain": "",
                            "options": [],
                            "showway": "",
                            "subinfo": "<p style=\"margin-top:0pt; margin-bottom:0pt; text-align:left; line-height:150%; font-family:STXihei; color: #5CA683;font-size:26rem;font-weight:400; \"><span style=\"font-family:'STXihei'; display: flex;\">农历九月九日，是中华民族的传统节日——重阳节。重阳节的起源可追溯至春秋战国时期（the Spring and Autumn Period and the  Warring States Period），距今已有 2 000 多年的历史。庆祝重阳节的活动一般包括出游赏景、登高远眺、观赏菊花（chrysanthemum）、饮菊花酒等。因为“九九”与“久久”同音，有长久长寿（longevity）的含义，所以重阳节又称为“老人节”。1989 年，我国将农历九月初九正式定为“中国老人节”“敬老节”。从此，重阳节又成为一个尊老、敬老、爱老、助老的节日。<\/span><\/p>",
                            "subanalysis": "",
                            "sortid": 1,
                            "file_name": "",
                            "user_answer": [],
                            "brief_answer": {},
                            "user_status": -1,
                            "answer_img": {},
                            "topic_answer": [{
                                "topic_id": 57,
                                "sub_id": 1,
                                "sortid": 1,
                                "ask": "",
                                "answer": "",
                                "askend": null,
                                "answer_id": 1,
                                "answer_url": "",
                                "answertitle": null,
                                "score": "8.00",
                                "operation_score": 0
                            }],
                            "video_list": [],
                            "isok": 0,
                            "isdone": 0,
                            "concat_answer": "",
                            "user_concat_answer": ""
                        }]
                    }
                ],
                completeType: '', // 答题完成后的操作 statistics：展示统计结果
            },

        ],
    },
]
export default content